import React, {useState,useEffect,useMemo} from 'react';
import Loader from 'react-loader-spinner';
import { Link } from 'react-router-dom';

import "react-datepicker/dist/react-datepicker.css";
import 'rc-time-picker/assets/index.css';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

import { useSelector,useDispatch } from 'react-redux'
import { initPassword, changePassword } from '../Redux/ChangePassword/ChangePasswordActions';

function ChangePassword(){
  // store data access start
  const changepassword_data = useSelector(state =>state.ChangePassword)
  // store data access End
  const dispatch = useDispatch()  // for accessing the redux function
  const [passwordHide,setPasswordHide] = useState(true);
  const [confirmPasswordHide,setConfirmPasswordHide] = useState(true);
  useEffect(() => {
      dispatch(initPassword());
  }, [dispatch]);
  // component all states define start
  // const [message,setMessage] = useState()

  const [inputValues,setInputValues] = useState({
                                          new_password:"",
                                          confirm_password: ""
  });

  const [error,setError] = useState(null)
  const [successStatus,setSuccessStatus] = useState(null)



// add data of classes api into constant,hook start
   useMemo(() =>{
     if(changepassword_data && changepassword_data.change_password && changepassword_data.change_password.object && changepassword_data.success_status === true){
       //setMessage("Password change successfully!")
     }
   },[changepassword_data])
// add data of classes api into constant,hook End

// examHandler function start
  const updateChangePasswordHandler = (event) =>{
     event.preventDefault()
     if(inputValues.new_password == ""){
       setError("new password is required!")
     } else if(inputValues.confirm_password == ""){
       setError("confirm password is required!")
     } else if(inputValues.new_password != inputValues.confirm_password){
       setError("password miss-match!")
     } else {
       setError(null);
       dispatch(changePassword(inputValues.new_password));
     }
  }
// examHandler function End

// resetHandler function start
   const resetHandler = (event) =>{
     event.preventDefault()
     window.location.reload(false);
   }
// resetHandler function End

        return (<>
<div className="breadcrumbs-area">
            <h3>Change Password</h3>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>Change Password</li>
            </ul>
          </div>
            <div className="row dashboard-card-six">


            <div className="col-6-xxxl col-12">
                <div className="card height-auto">

                {changepassword_data.is_loading === true ? (<div className="card-body">
                      <div className="Student-Loader">
                      <Loader
                      className = "student-detail-loader"
                    type="MutatingDots"
                    color="#fea801"
                    height={150}
                    width={150}
                   />
                      </div>
                    </div>)
                   :
                  (<div className="card-body">
                    
                    <div className="heading-layout1 bg-darkblue">
                      <div className="item-title">
                        <h3 className='text-light'>Change Password</h3>
                        
                      </div>
                    </div>

                    {changepassword_data.change_password && changepassword_data.change_password.request_status === true ? (<div className="success-greeting1">
                        <h2 className="addtimesuccess">Password change successfully!</h2>
                        </div>): null}
                        {changepassword_data.get_error && changepassword_data.get_error.object && changepassword_data.get_error.object.error ? (<div className="success-greeting1">

                        <h2 className="addtimeerror">{changepassword_data.get_error.object.error}</h2>
                        </div>): null}
                        
                        {error ? (<div className="success-greeting1">
                         <h2 className="addtimeerror">{error}</h2>
                        </div>): null}
                    
                    <form className="new-added-form" onSubmit={(e) =>updateChangePasswordHandler(e)}>
                      <div className="row">
                        
                        <div className="col-12-xxxl col-lg-12 col-12 form-group">
                          <label>New Password *</label>
                          <input type={passwordHide ? "password" : "text"} placeholder className="form-control" value={inputValues.new_password} onChange={(e) =>setInputValues({...inputValues,new_password:e.target.value})} required/>
                          {passwordHide ? (
                              <i className="far fa-eye eye-password-icon"  onClick={() =>setPasswordHide(!passwordHide)}></i>
                            ) : (
                              <i className="fa fa-eye-slash eye-password-icon" aria-hidden="true" onClick={() =>setPasswordHide(!passwordHide)}></i>
                            )}
                          {error != null && error.new_password ? (<h6 className="addStudent-error">*{JSON.stringify(error.new_password).replace(/[\[\]"]+/g,"")}</h6>):null}
                        </div>

                        <div className="col-12-xxxl col-lg-12 col-12 form-group">
                          <label>Confirm Password *</label>
                          <input type={confirmPasswordHide ? "password" : "text"} placeholder className="form-control" value={inputValues.confirm_password} onChange={(e) =>setInputValues({...inputValues, confirm_password:e.target.value})} required/>
                          {confirmPasswordHide ? (
                              <i className="far fa-eye eye-password-icon"  onClick={() =>setConfirmPasswordHide(!confirmPasswordHide)}></i>
                            ) : (
                              <i className="fa fa-eye-slash eye-password-icon" aria-hidden="true" onClick={() =>setConfirmPasswordHide(!passwordHide)}></i>
                            )}
                          {error != null && error.confirm_password ? (<h6 className="addStudent-error">*{JSON.stringify(error.confirm_password).replace(/[\[\]"]+/g,"")}</h6>):null}
                        </div>
                        

                        <div className="col-12 form-group mg-t-8" style={{paddingTop:"20px"}}>
                          <button type="submit" style={{marginLeft:"10px"}} className="btn-fill-lg bg-blue-dark btn-hover-yellow right-float">Save</button>
                          <button type="reset" className="btn-fill-lg btn-gradient-yellow btn-hover-bluedark right-float" onClick={(e) =>resetHandler(e)}>Reset</button>
                        </div>
                      </div>
                    </form>
                  </div>
                )}
                </div>
              </div>
              </div>
              </>
        );
}

export default ChangePassword;
